import { AsyncUserModuleHandler } from "@/components/AsyncComponents"

export const withUserModule = (WrappedComponent: any) => {
    return {
        template: `<Handler><WrappedComponent></WrappedComponent></Handler>`,
        components: {
            WrappedComponent,
            Handler: AsyncUserModuleHandler
        },
    }
}